<form class="form" [formGroup]="loginForm">
    <div class="form-row control email">
      <p class="label">Benutzername</p>
      <input type="email" class="input" formControlName="email">
    </div>
    <app-password formControlName="password"></app-password>
    <div class="form-row actions">
      <button class="red-button login-btn" (click)="submitForm()" [disabled]="loginForm.invalid">Anmelden</button>
    </div>
</form>